import { render, staticRenderFns } from "./material-account-config.vue?vue&type=template&id=1d1c9328&scoped=true"
import script from "./material-account-config.vue?vue&type=script&setup=true&lang=js"
export * from "./material-account-config.vue?vue&type=script&setup=true&lang=js"
import style0 from "./material-account-config.vue?vue&type=style&index=0&id=1d1c9328&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1c9328",
  null
  
)

export default component.exports